<template>
    <div>
        <app-overlay-loader v-if="preloader"/>
        <form v-else ref="form">
            <app-form-group
                page="page"
                :label="$t('first_name')"
                type="text"
                v-model="formData.first_name"
                :placeholder="$placeholder('first_name','')"
                :error-message="$errorMessage(errors, 'first_name')"
            />
            <app-form-group
                page="page"
                :label="$t('last_name')"
                type="text"
                v-model="formData.last_name"
                :placeholder="$placeholder('last_name','')"
                :error-message="$errorMessage(errors, 'last_name')"
            />
            <app-form-group
                page="page"
                :label="$t('email')"
                type="text"
                v-model="formData.email"
                :placeholder="$placeholder('email','')"
                :error-message="$errorMessage(errors, 'email')"
            />
            <app-form-group
                page="page"
                :label="$t('employee_id')"
                type="text"
                v-model="formData.employee_id"
                :placeholder="$placeholder('employee_id','')"
                :error-message="$errorMessage(errors, 'employee_id', true, true)"
            />
            <app-form-group
                page="page"
                :label="$t('phone_number')"
                type="tel-input"
                v-model="formData.phone"
                disabled
                :placeholder="$placeholder('phone_number','')"
                :error-message="$errorMessage(errors, 'phone_number')"
            />
            <app-form-group
                page="page"
                :label="$t('gender')"
                type="radio"
                :list="[
                {id:'male',value: $t('male')},
                {id:'female', value:  $t('female')},
                // {id:'other', value:  $t('others')}
            ]"
                v-model="formData.gender"
                :error-message="$errorMessage(errors, 'gender')"

            />
            <app-form-group
                page="page"
                type="checkbox"
                :class="'font-size-90 col-md-12'"
                :label="$t('select_your_weekend_days')"
                :list="weekdays"
                v-model="formData.weekdays"
                radio-checkbox-wrapper="row"
                custom-checkbox-type="checkbox-default col-md-3"
                :error-message="$errorMessage(errors, 'weekdays')"
            />

          <app-form-group-selectable
              page="page"
              type="multi-select"
              :label="$t('locations')"
              list-value-field="name"
              v-model="formData.locations"
              :chooseLabel="$t('locations')"
              :error-message="$errorMessage(errors, 'locations')"
              :fetch-url="SELECTABLE_LOCATION"
          />
            <app-form-group
                page="page"
                :label="$t('birthday')"
                type="date"
                v-model="formData.date_of_birth"
                :placeholder="$placeholder('date_of_birth','')"
                :error-message="$errorMessage(errors, 'date_of_birth')"
            />
            <app-form-group
                page="page"
                type="select"
                :label="$t('nationality')"
                :placeholder="$placeholder('nationality')"
                :chooseLabel="$t('nationality')"
                v-model="formData.nationality"
                :list="countries1"
                :error-message="$errorMessage(errors, 'nationality')"
            />
<!--            <app-form-group-->
<!--                page="page"-->
<!--                type="select"-->
<!--                :label="$t('nationality')"-->
<!--                :placeholder="$placeholder('nationality')"-->
<!--                :chooseLabel="$t('nationality')"-->
<!--                v-model="formData.nationality"-->
<!--                :list="countries"-->
<!--                :error-message="$errorMessage(errors, 'nationality')"-->
<!--            />-->
<!--            <app-form-group-->
<!--                page="page"-->
<!--                type="select"-->
<!--                :label="$t('line_manager')"-->
<!--                list-value-field="first_name"-->
<!--                :placeholder="$placeholder('line_manager')"-->
<!--                :chooseLabel="$t('line_manager')"-->
<!--                v-model="formData.line_manager"-->
<!--                :list="fetchManagers"-->
<!--                :error-message="$errorMessage(errors, 'line_manager')"-->
<!--            />-->

<!--            <app-form-group-selectable-->
<!--                v-if="modalType === 'line_manager'"-->
<!--                type="select"-->
<!--                :label="$t('line_manager')"-->
<!--                list-value-field="name"-->
<!--                v-model="formData.line_manager"-->
<!--                :chooseLabel="$t('line_manager')"-->
<!--                :error-message="$errorMessage(errors, 'line_manager')"-->
<!--                :fetch-url="apiUrl.LINE_MANAGERS"/>-->

          <app-form-group-selectable
              page="page"
              type="select"
              :label="$t('line_manager')"
              list-value-field="full_name"
              v-model="formData.line_manager"
              :chooseLabel="$t('line_manager')"
              :error-message="$errorMessage(errors, 'line_manager')"
              :fetch-url="apiUrl.LINE_MANAGERS"
          />

<!--            <app-form-group-->
<!--                page="page"-->
<!--                :label="$t('contract_start_date')"-->
<!--                type="date"-->
<!--                v-model="formData.contract_start_date"-->
<!--                :placeholder="$placeholder('contract_start_date','')"-->
<!--                :error-message="$errorMessage(errors, 'contract_start_date')"-->
<!--            />-->
<!--            <app-form-group-->
<!--                page="page"-->
<!--                :label="$t('contract_end_date')"-->
<!--                type="date"-->
<!--                v-model="formData.contract_end_date"-->
<!--                :placeholder="$placeholder('contract_end_date','')"-->
<!--                :error-message="$errorMessage(errors, 'contract_end_date')"-->
<!--            />-->
            <app-form-group
                page="page"
                :label="$t('about_me')"
                type="textarea"
                v-model="formData.about_me"
                :placeholder="$textAreaPlaceHolder('about_me','')"
                :error-message="$errorMessage(errors, 'about_me')"
            />
            <div class="form-group mt-5 mb-0">
                <app-submit-button @click="submitData" :title="$t('save')" :loading="loading"/>
            </div>
        </form>
    </div>

</template>
<script>
import FormHelperMixins from "../../../../../../common/Mixin/Global/FormHelperMixins";
import {formatDateForServer} from "../../../../../../common/Helper/Support/DateTimeHelper";
import {mapState} from "vuex";
import {EMPLOYEES, LINE_MANAGERS, SELECTABLE_LOCATION} from "../../../../../Config/ApiUrl";
import optional from "../../../../../../common/Helper/Support/Optional";
import countries from "../../Helper/countries";
import {addChooseInSelectArray} from "../../../../../../common/Helper/Support/FormHelper";
import {axiosGet} from "../../../../../../common/Helper/AxiosHelper";

export default {
    name: "EmployeePersonalDetails",
    mixins: [FormHelperMixins],
    data() {
        return {
            formData: {},
            preloader: true,
            managers: [],
            weekdays: [
              {id: "sun", value: this.$t("sunday")},
              {id: "mon", value: this.$t("monday")},
              {id: "tue", value: this.$t("tuesday")},
              {id: "wed", value: this.$t("wednesday")},
              {id: "thu", value: this.$t("thursday")},
              {id: "fri", value: this.$t("friday")},
              {id: "sat", value: this.$t("saturday")},
            ],
          SELECTABLE_LOCATION,
        }
    },
    methods: {
        submitData() {
            this.loading = true;
            const formData = {...this.formData};
            formData.date_of_birth = formatDateForServer(formData.date_of_birth);
            formData.weekdays = JSON.stringify(formData.weekdays);
            this.submitFromFixin(`patch`, `${EMPLOYEES}/${this.formData.id}/profile-update`, formData);
        },
        afterSuccess(response) {
            this.loading = false;
            this.$toastr.s('', response.data.message);
            this.scrollToTop(false)
            // setTimeout(() => location.reload())
        },
      },

    computed: {
        ...mapState({
            employeeDetails: state => state.employees.employee
        }),
        countries1() {
          return addChooseInSelectArray(countries, 'value', this.$t('country'))
        },
        fetchManagers() {
          console.log('fetchManagers');
          axiosGet('api/employee/fetch-managers')
              .then(res => {
                console.log(res.data)
                return res.data;
              })
              .catch(error => {
                console.log(error);
              })
        }
    },

    watch: {
        employeeDetails: {
            handler: function (employee) {
                if (!!Object.keys(employee).length) {
                    this.preloader = false
                }
                this.formData = {
                    ...employee,
                    employee_id: employee.profile ? employee.profile.employee_id : '',
                    gender: employee.profile ? employee.profile.gender : '',
                    about_me: employee.profile ? employee.profile.about_me : '',
                    phone: employee.phone,
                    date_of_birth: optional(employee, 'profile', 'date_of_birth') ? new Date(employee.profile.date_of_birth) : '',
                    weekdays: employee.weekdays ? JSON.parse(employee.weekdays) : [],
                    locations: this.collection(employee.locations).pluck()
                }
            },
            deep: true,
            immediate: true
        }
    }
}
</script>